import { render, staticRenderFns } from "./jicaiCreate.vue?vue&type=template&id=1a2f9a1c&scoped=true&"
import script from "./jicaiCreate.vue?vue&type=script&lang=js&"
export * from "./jicaiCreate.vue?vue&type=script&lang=js&"
import style0 from "./jicaiCreate.vue?vue&type=style&index=0&id=1a2f9a1c&prod&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1a2f9a1c",
  null
  
)

export default component.exports